import React from "react";
import { HEADING } from "./constants";

const InStudioStylingHeading = ({ text, alignment }) => {
    return <h1 className={HEADING}>{text}</h1>;
};

export default InStudioStylingHeading;
